export default __webpack_public_path__ + "static/media/eva_spiral_stairs.805b8a09.jpg";